module.exports = __webpack_public_path__ + "static/media/binance-settings-figure.4cc61aac.png";